const NotificationConstants = {
  type: [{
    id: 1,
    header: 'NOTIFY TRANSPORTER ON INDENT CREATION',
  }, {
    id: 2,
    header: 'NOTIFY CONSIGNEE ON INDENT DISPATCH',
  }, {
    id: 3,
    header: 'NOTIFY NEW TRANSPORTER ON ADDITION TO MDM',
  }],
  allowedTypes: [1, 2, 3],

  defaultValue: {
    notifications: [
      {
        notification_type: 1,
        email: true,
        sms: true,
      },
      {
        notification_type: 2,
        email: true,
        sms: true,
      },
      {
        notification_type: 3,
        email: true,
        sms: true,
      },
    ],
  },
};

module.exports = { NotificationConstants };
